import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import $ from 'jquery';

import { selectUrlData } from '../../redux/train/train.selector';

import iconBack from '../../assets/back-arrow.png';
import iconClose from '../../assets/close.png';

class FaqDetailsMiscell extends React.Component {
    constructor(props) {
        super(props);
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $;
    }
    myFunction(e) {
        $('.single-faq').removeClass('active');
        $(e).parent('.single-faq').addClass('active');
    }
    render() {
        const { urlData } = this.props;
        return (
            <div>
                <div className="faq-header">
                    <a href={'/ttbhelp?' + urlData}><img src={iconBack} alt="" title="" /></a>
                    <h2>Frequently Asked Questions(FAQ):</h2>
                    <Link to={'/ttbhelp/faq'}><img src={iconClose} alt="" title="" /></Link>
                </div>
                <div className="faq-content">
                    <h4>Miscellaneous</h4>

                    <h2>What do you need help with?</h2>

                    <div className="faq-accordian">
                        <div className="single-faq active">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What should I do if I forget to bring my ID proof during the journey?</h3>
                            <p>If you don’t have your ID proof, you can show an electronic copy from DigiLocker or other government-approved apps. Inform the TTE to avoid penalties.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I claim compensation for a delayed or canceled train?</h3>
                            <p>File a TDR (Ticket Deposit Receipt) on RailYatri or IRCTC if your train is delayed or canceled. You can also contact RailYatri customer support for immediate guidance.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What are the emergency contact numbers for Indian Railways?</h3>
                            <p><span>For All Public Grievances:</span> Please DIAL - <span>139</span>.</p>
                            <p><span>For All Security Related Issues:</span> Please DIAL - <span>182</span>.</p>

                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I provide feedback or suggestions for RailYatri?</h3>
                            <li>Open the RailYatri app.</li>
                            <li>Navigate to the <em>"Feedback"</em> section from the main menu (left side).</li>
                            <li>Submit your query.</li>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateProps = createStructuredSelector({
    urlData: selectUrlData
})

export default connect(mapStateProps, null)(FaqDetailsMiscell);
